import Main from './js/mainMidoci'

// eslint-disable-next-line
new Main()



// WEBPACK FOOTER //
// ./src/app.js